import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LanguageDataService } from '../data-services/language-data.service';

@Injectable({
    providedIn: 'root'
})

export class LanguageService{

    
    lang: string;
    constructor(private service : LanguageDataService) {
    }

    getAllLanguage(): Promise<any> 
    {
        return this.service.getAllLanguage();
    }

    getLocalizationData(languagCode: string): Observable<any>
    {
        this.lang = languagCode;
        return this.service.getLocalizationData(languagCode);
    }
}